import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Map, List, fromJS } from 'immutable';

import * as targetActions from 'modules/target';
import * as currentStatusActions from 'modules/currentStatus';

import { Target } from 'components';

let resizeTarget;
let SEARCH_VALUE = '';
class CtTarget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      targetScrollData: { isScroll: false, height: 400 },
      searchText: '',
      tempFilter: {},
      filterUpdate: true,
      popupOpen: false
    };
  }

  componentDidMount() {
    this.onGetTarget(true);
    window.addEventListener('resize', this.onResize);
  }

  // 태그 선택시 대상자 rerender 처리
  componentDidUpdate(prevProps, prevState) {
    // 대상자 Height 설정
    // 데이터가 없으면 rf.scrollable이 아예 생성 안됨
    const rf = this.refScroll;
    if (!!rf && !!rf.scrollable) {
      const { heightData, numberOfChildren } = rf.state.infiniteComputer;
      const isScroll = heightData * numberOfChildren > rf.scrollable.parentElement.clientHeight;

      // 높이가 달라진 경우
      // 스크롤이 생성 여부
      if (
        rf.computedProps.containerHeight !== rf.scrollable.parentElement.clientHeight ||
        isScroll !== this.state.targetScrollData['isScroll']
      ) {
        this.setState({
          targetScrollData: { isScroll: isScroll, height: rf.scrollable.parentElement.clientHeight }
        });
      }
    }

    const { needReload, selectedTag, targetParam, multiType, targetDataByTargetNo } = this.props;
    if (
      // 대상자 새로고침
      (needReload && !this.state.isLoading) ||
      // 선택한 태그가 변경되었을 때
      String(selectedTag.toJS()) !== String(prevProps.selectedTag.toJS()) ||
      // parameter가 변경되었을때
      targetParam !== prevProps.targetParam ||
      // 여러 태그 선택 타입이 변경되었을 때
      multiType !== prevProps.multiType
      // 대상자가 추가되었을 때
      // || targetDataByTargetNo !== prevProps.targetDataByTargetNo
    ) {
      this.onGetTarget(true);

      // 새로고침시 스크롤 맨위로 이동
      if (!!rf && !!rf.scrollable) {
        rf.scrollable.scrollTop = 0;
        // rf.infiniteHandleScroll(0);
        // rf.handleScroll(0);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.onFilterCancel();
  }

  // 브라우저 리사이즈시의 처리
  onResize = () => {
    clearTimeout(resizeTarget);
    resizeTarget = setTimeout(() => {
      this.forceUpdate();
    }, 300);
  };

  // 대상자 리스트
  onGetTarget = async refresh => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        const {
          TargetActions,
          CurrentStatusActions,
          tagDataByTagNo,
          selectedTag,
          selectTarget,
          targetParam,
          page,
          totalPages,
          multiType
        } = this.props;

        const tagNoArray =
          (selectedTag.toJS().toString() === 'all-tag' && 'all-tag') ||
          (selectedTag.toJS().toString() === 'no-tag' && 'no-tag') ||
          JSON.stringify(selectedTag);
        if (refresh) {
          const param = {
            tagNoArray: tagNoArray,
            filter: JSON.stringify(targetParam.get('filter')),
            sort: JSON.stringify(targetParam.get('sort')),
            offset: 0,
            limit: targetParam.get('limit'),
            refresh: !!refresh,
            multiType: multiType
          };

          CurrentStatusActions.checkAllTarget({ targetNoArray: [], isAllCheckTarget: 0 });
          await TargetActions.getTarget(param);

          setTimeout(() => {
            !!this.refScroll && !!this.refScroll.scrollable && this.refScroll.handleScroll(0);
          }, 500);
        } else if (totalPages > page) {
          const param = {
            tagNoArray: tagNoArray,
            filter: JSON.stringify(targetParam.get('filter')),
            sort: JSON.stringify(targetParam.get('sort')),
            offset: targetParam.get('limit') * page,
            limit: targetParam.get('limit'),
            multiType: multiType
          };

          // 전체선택일 경우 일부 선택으로 변경
          if (selectTarget.get('isAllCheckTarget') === 1) {
            CurrentStatusActions.changeSelectTarget({ name: 'isAllCheckTarget', value: 3 });
          }

          await TargetActions.getTarget(param);
        }

        !!targetParam.getIn(['filter', 'searchAll']) &&
          this.setState({ searchText: targetParam.getIn(['filter', 'searchAll']) });
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  // 대상자 정렬
  onSortOrdering = e => {
    const { TargetActions, targetParam } = this.props;

    let orderValue = 'DESC';
    if (targetParam.get('sort')[0]['order'] === 'DESC') {
      orderValue = 'ASC';
    }
    TargetActions.changeTargetParam({
      name: 'sort',
      value: [{ order: orderValue, field: targetParam.get('sort')[0]['field'] }]
    });
  };

  // 대상자 정렬
  onSortTarget = (e, data) => {
    const { TargetActions, targetParam } = this.props;

    TargetActions.changeTargetParam({
      name: 'sort',
      value: [{ field: data.value, order: targetParam.get('sort')[0]['order'] }]
    });
  };

  // 대상자 검색
  onSearchTarget = e => {
    let searchValue = '';
    if (e.key === 'Enter' || e.target.id === 'bt-searchTarget' || e.target.parentNode.id === 'bt-searchTarget') {
      searchValue = SEARCH_VALUE;

      const { TargetActions, targetParam } = this.props;
      const filter = targetParam.get('filter').toJS();
      if (searchValue !== filter['searchAll']) {
        // filter 지우기
        if (searchValue === '') {
          delete filter['searchAll'];
        } else {
          filter['searchAll'] = searchValue;
        }

        TargetActions.changeTargetParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 스크롤 ref 등록
  onRefScroll = Scroll => {
    if (!!Scroll) {
      this.refScroll = Scroll;
    }
  };

  // 최근 훈련 결과 필터
  onFilterExamInfo = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['examInfoArray'] === 'undefined') {
      filter['examInfoArray'] = [data.value];
    } else {
      const indexArray = filter['examInfoArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['examInfoArray'].push(data.value);
      } else {
        filter['examInfoArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['examInfoArray'].length === 0 && delete filter['examInfoArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 소속 필터
  onFilterDivision = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['targetDivisionArray'] === 'undefined') {
      filter['targetDivisionArray'] = [data.value];
    } else {
      const indexArray = filter['targetDivisionArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['targetDivisionArray'].push(data.value);
      } else {
        filter['targetDivisionArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['targetDivisionArray'].length === 0 && delete filter['targetDivisionArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 직급 필터
  onFilterPosition = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['targetPositionArray'] === 'undefined') {
      filter['targetPositionArray'] = [data.value];
    } else {
      const indexArray = filter['targetPositionArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['targetPositionArray'].push(data.value);
      } else {
        filter['targetPositionArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['targetPositionArray'].length === 0 && delete filter['targetPositionArray'];
      }
    }

    this.setState({
      tempFilter: filter,
      filterUpdate: false
    });
  };

  // 필터 초기화
  onFilterCancel = () => {
    const { TargetActions } = this.props;

    TargetActions.changeTargetParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // //파라미터 초기값 가져오기
  // getFilterParam = () => {
  //   const { targetParam } = this.props;
  //   const filter = targetParam.get('filter').toJS();
  //   INITIAL_FILTER = Object.assign({}, filter);
  // };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  // 전체 선택 체크박스
  handleCheckAllTarget = e => {
    const { CurrentStatusActions, targetOrdering, selectTarget } = this.props;

    // 전체 선택
    if (targetOrdering.size !== selectTarget.get('targetNoArray').size) {
      CurrentStatusActions.checkAllTarget({ targetNoArray: targetOrdering, isAllCheckTarget: 1 });
      // 해제
    } else {
      CurrentStatusActions.checkAllTarget({ targetNoArray: [], isAllCheckTarget: 0 });
    }
  };

  // 전체 숨겨진 대상까지 체크박스
  handleCheckTotalTarget = e => {
    const { CurrentStatusActions, selectTarget } = this.props;

    if (selectTarget.get('isAllCheckTarget') !== 2) {
      CurrentStatusActions.checkAllTarget({ isAllCheckTarget: 2 });
    } else {
      CurrentStatusActions.checkAllTarget({ isAllCheckTarget: 0 });
    }
  };

  // 대상자 단일 선택(체크)
  handleCheckTarget = (targetNo, shiftCheck) => {
    const { CurrentStatusActions, targetOrdering, selectTarget } = this.props;

    if (shiftCheck && selectTarget.get('lastCheck') !== 0) {
      // true면 지우기 false는 추가
      const isRemove = selectTarget.get('targetNoArray').indexOf(selectTarget.get('lastCheck')) === -1 ? true : false;
      const startNo = targetOrdering.findIndex(tNo => tNo === selectTarget.get('lastCheck'));
      const endNo = targetOrdering.findIndex(tNo => tNo === targetNo);

      const targetArray = [];
      targetOrdering.map((eachTargetNo, index) => {
        if ((startNo <= index && index <= endNo) || (endNo <= index && index <= startNo)) {
          targetArray.push(eachTargetNo);
        }
      });

      CurrentStatusActions.checkTargetMulti({ targetNo, targetArray, isRemove, totalTarget: targetOrdering.size });
    } else {
      CurrentStatusActions.checkTarget({ targetNo, totalTarget: targetOrdering.size });
    }
  };

  // 대상자 선택
  handleSelectTarget = targetNo => {
    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.selectTarget({ targetNo });
  };

  //체크 취소
  cancleCheck = () => {
    const { TargetActions, targetParam } = this.props;
    const filter = targetParam.get('filter').toJS();
    this.setState({
      tempFilter: filter
    });
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { targetParam } = this.props;
    const filter = targetParam.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false,
      filterUpdate: true
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { TargetActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    this.setState({ filterUpdate: true });
    TargetActions.changeTargetParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 팝업 열기/닫기
  handlePopup = value => {
    this.setState({
      popupOpen: value
    });
  };

  render() {
    const {
      selectTarget,
      selectedTag,
      tagDataByTagNo,
      targetOrdering,
      targetDataByTargetNo,
      targetParam,
      targetFilter,
      page,
      totalPages,
      totalTarget
    } = this.props;
    // function
    const {
      onGetTarget,
      onSortTarget,
      onSearchChange,
      onSearchTarget,
      handleCheckAllTarget,
      handleCheckTotalTarget,
      handleCheckTarget,
      handleSelectTarget,
      onRefScroll,
      onFilterExamInfo,
      onFilterDivision,
      onFilterPosition,
      onFilterCancel,
      onSortOrdering,
      takeSearchValue,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter,
      handlePopup
    } = this;
    const { tempFilter, filterUpdate, isLoading, popupOpen } = this.state;
    return (
      <Target
        tagDataByTagNo={tagDataByTagNo}
        targetOrdering={targetOrdering}
        targetDataByTargetNo={targetDataByTargetNo}
        targetParam={targetParam}
        selectTarget={selectTarget}
        selectedTag={selectedTag}
        targetScrollData={this.state.targetScrollData}
        isLoading={isLoading}
        page={page}
        totalPages={totalPages}
        totalTarget={totalTarget}
        onGetTarget={onGetTarget}
        onSortTarget={onSortTarget}
        onSortOrdering={onSortOrdering}
        onSearchChange={onSearchChange}
        onSearchTarget={onSearchTarget}
        handleCheckAllTarget={handleCheckAllTarget}
        handleCheckTotalTarget={handleCheckTotalTarget}
        handleCheckTarget={handleCheckTarget}
        handleSelectTarget={handleSelectTarget}
        onRefScroll={onRefScroll}
        // 필터
        searchText={this.state.searchText}
        targetFilter={targetFilter}
        onFilterExamInfo={onFilterExamInfo}
        onFilterDivision={onFilterDivision}
        onFilterPosition={onFilterPosition}
        onFilterCancel={onFilterCancel}
        takeSearchValue={takeSearchValue}
        searchTextRef={searchTextRef}
        executeFilter={executeFilter}
        cancleCheck={cancleCheck}
        filterClose={filterClose}
        tempFilter={tempFilter}
        filterUpdate={filterUpdate}
        scrollRef={this.refScroll}
        popupOpen={popupOpen}
        handlePopup={handlePopup}
      />
    );
  }
}

const mapStateToProps = state => ({
  needReload: state.target.get('needReload'),
  page: state.target.get('page'),
  totalPages: state.target.get('totalPages'),
  totalTarget: state.target.get('totalTarget'),
  targetOrdering: state.target.get('targetOrdering'),
  targetDataByTargetNo: state.target.get('targetDataByTargetNo'),
  targetParam: state.target.get('param'),
  targetFilter: state.target.get('filter'),
  tagDataByTagNo: state.tag.get('tagDataByTagNo'),
  selectedTag: state.currentStatus.getIn(['tag', 'selectedTag']),
  multiType: state.currentStatus.getIn(['tag', 'multiType']),
  selectTarget: state.currentStatus.getIn(['target', 'selectTarget'])
});

const mapDispatchToProps = dispatch => ({
  TargetActions: bindActionCreators(targetActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CtTarget);



// WEBPACK FOOTER //
// ./src/script/containers/target/CtTarget.js